import React from 'react';

const Dot: React.FC<{ active: boolean }> = ({ active }) => (
  <div
    className={`ml1 ba b--navy br-100 ${active && 'bg-navy'}`}
    style={{ width: 10, height: 10 }}
  />
);

const FiverMiniViz: React.FC<{ value: 1 | 2 | 3 | 4 | 5 }> = ({ value }) => (
  <div className="flex">
    <Dot active={value >= 1} />
    <Dot active={value >= 2} />
    <Dot active={value >= 3} />
    <Dot active={value >= 4} />
    <Dot active={value >= 5} />
  </div>
);

export default FiverMiniViz;
